import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { exitGuard } from '../guards/exit.guard';
import { Role } from '../models/role';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'violation',
		pathMatch: 'full'
	},
	{
		path: 'login',
		loadComponent: () => import('../components/login/login.component').then((m) => m.LoginComponent)
	},
	{
		path: 'violation',
		loadChildren: () => import('./routes/violation.routes').then((m) => m.VIOLATION_ROUTES)
	},
	{
		path: 'ticket-preview',
		loadComponent: () => import('../components/violation-ticket/violation-ticket.component').then((m) => m.ViolationTicketComponent),
		canActivate: [authGuard],
		canDeactivate: [exitGuard],
		data: {
			roles: [Role.PEA, Role.LEO]
		}
	},
	{
		path: 'dashboard',
		loadChildren: () => import('./routes/dashboard.routes').then((m) => m.DASHBOARD_ROUTES)
	},
	{
		path: '404',
		loadComponent: () => import('../components/not-found/not-found.component').then((m) => m.NotFoundComponent)
	},
	{
		path: '**',
		redirectTo: '404'
	}
];
